module.exports = __webpack_public_path__ + "files/ae31df5a6260de581738d681fe9c799e.png";